"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LoginFormComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _formValidations = require("../../helpers/formValidations");
var _APPasswordInput = _interopRequireDefault(require("../common/APPasswordInput/APPasswordInput"));
var _redirectIfAuthorized = _interopRequireDefault(require("../../hocs/redirectIfAuthorized"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _TradingServerComponent = _interopRequireDefault(require("../TradingServer/TradingServerComponent"));
var _FMSGateway = _interopRequireDefault(require("../FMSGateway"));
var _commonComponent = require("../../propTypes/commonComponent");
require("../../styles/components/common/StandaloneForm.css");
require("./LoginFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('standalone-form');
var loginFormClasses = (0, _cssClassesHelper.getBEMClasses)('login-form');
var LoginFormComponent = exports.LoginFormComponent = function LoginFormComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var handleSubmit = props.handleSubmit,
    errorMsg = props.errorMsg,
    submitting = props.submitting,
    doSubmit = props.doSubmit,
    isConnected = props.isConnected,
    useEmailAsUsername = props.useEmailAsUsername,
    active = props.active,
    siteName = props.siteName,
    gateway = props.gateway,
    formGateway = props.formGateway,
    resetForm = props.resetForm;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    customGateway = _useState2[0],
    setCustomGateway = _useState2[1];
  if (formGateway === 'CUSTOM' && !customGateway) {
    setCustomGateway(true);
    resetForm('gateway');
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('container'), " ").concat(loginFormClasses('container'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('header'), " ").concat(loginFormClasses('header'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('header-text'), " ").concat(loginFormClasses('header-text'))
  }, t('Log In to {{n}}', {
    n: siteName
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])('/'),
    className: baseClasses('close-icon')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "close",
    classModifiers: "big"
  }))), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit(function (values) {
      return doSubmit(values, isConnected);
    }),
    className: "".concat(baseClasses('form'), " ").concat(loginFormClasses('form'))
  }, errorMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: baseClasses('error')
  }, errorMsg), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    type: "text",
    name: "username",
    customClass: loginFormClasses(),
    label: useEmailAsUsername ? t('Email') : t('Username'),
    validate: [_formValidations.required]
  }), /*#__PURE__*/_react["default"].createElement(_APPasswordInput["default"], {
    type: "password",
    name: "password",
    customClass: loginFormClasses(),
    label: t('Password'),
    validate: [_formValidations.required]
  }), (!gateway || customGateway) && /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    type: "text",
    name: "gateway",
    customClass: loginFormClasses(),
    label: t('Gateway'),
    validate: [_formValidations.required]
  }), !customGateway && Array.isArray(gateway) && /*#__PURE__*/_react["default"].createElement(_TradingServerComponent["default"], null), /*#__PURE__*/_react["default"].createElement(_FMSGateway["default"], null), /*#__PURE__*/_react["default"].createElement("hr", {
    className: loginFormClasses('separator')
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    disabled: submitting,
    customClass: loginFormClasses(),
    styleName: _commonComponent.styleNames.additive
  }, submitting ? t('Processing...') : t('Log In'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(baseClasses('footer'), " ").concat(loginFormClasses('footer'))
  }, active && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])('/signup'),
    className: loginFormClasses('link'),
    disabled: true
  }, t('Sign Up')), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('footer-separator')
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])('/problem-logging-in'),
    className: loginFormClasses('link'),
    disabled: true
  }, t('Problems Logging In?'))));
};
LoginFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
LoginFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  referrer: _propTypes["default"].string
};
var _default = exports["default"] = (0, _redirectIfAuthorized["default"])(LoginFormComponent);